module.exports = {
    label: {
        registertitle: 'Register for a free ChurchTools installation',
        churchname: 'Name of your church/ministry',
        city: 'City',
        countrycode: 'Country',
        instancename: {
            short: 'Short installation name',
            long: 'Short installation name'
        },
        yoururl: 'Your resulting ChurchTools URL: ',
        baselanguage: {
            short: 'Language',
            long:
                'The language your system will be installed in. After that your users can choose from a large variety of languages.'
        },
        contactperson: 'About yourself',
        contactpersonDenomination: 'About the administrator',
        churchinformation: 'About your church',
        churchinformationDenomination: 'About the church',
        optionalInformation: 'Further information',
        name: 'Name',
        firstname: 'First name',
        lastname: 'Last name',
        email: 'Email',
        phone: 'Telephone in case of questions',
        discountcode: 'Discount code',
        comments: 'Other comments',
        checkagbs: 'I have read the {link} and accept them herewith.',
        checkgdpr: 'I have read the {link}.',
        checknewsletter:
            'I would like to receive the monthly newsletter with tips and news from ChurchTools. I am aware that I can revoke my consent at any time with effect for the future. Note: A corresponding unsubscribe link can be found in every newsletter..',
        checknewsletterDenomination:
            'The administrator should receive the monthly newsletter with tips and news from ChurchTools.',
        agbs: 'Terms & Conditions',
        gdpr: 'privacy policy',
        website: 'Website or Facebook site',
        currentWebsite: 'Current website or Facebook site',
        username: 'Username',
        password: 'Password',
        login: 'Support Login',
        setupService: 'Setup Service',
        setupMeeting: 'Date selection',
        useSetupService: 'Use free setup service',
        pleaseSelectDate: 'Please select a date:',
        with: 'with',
        churchtoolsWebsite: 'ChurchTools Website',
        registerWebsite: 'Additionally test ChurchTools Website for free',
        alreadyCustomer: 'Your church is already using ChurchTools?',
        notYetCustomer: 'Your church is not a ChurchTools customer yet?',
        niceHeader: 'How nice that you would like to try ChurchTools!',
        problemHeader: 'What concern or problem would you like to solve with the help of ChurchTools?',
        problemDescription:
            'Answer this question as specifically as possible (max. 250 characters). This will help you to focus even more on what you want to achieve in the next 30 days with the trial installation of ChurchTools.',
        justLooking: '"I actually just want to look."',
        justLookingDescription:
            'In this case, we recommend our demo installation, which is perfect for a quick overview of the many functions of ChurchTools. It is already filled with sample data so that you can test all modules effortlessly.',
        justLookingDescription2:
            'You have a full 3 days to explore the demo. If this time is not enough, you can create a new demo at any time.',
        andNowAFewDetails: 'And now a few details ...',
        detailsAboutYourChurch: '... about your church',
        detailsAboutYou: '... about yourself',
        institutionId: 'Institutions-ID'
    },
    button: {
        register: "Let's start",
        registering: 'Please wait...',
        login: 'Login',
        demo: 'Create Demo'
    },
    link: {
        dataprivacy: 'https://www.church.tools/en/data-security',
        impressum: 'https://www.church.tools/en/impressum',
        agbs: 'https://church.tools/en/agb',
        demo: 'https://ccp.church.tools/demo',
        demoXXX: 'https://www.church.tools/de/churchtools-testen?cta=ccp'
    },
    linklabel: {
        dataprivacy: 'Privacy Policy',
        impressum: 'Impressum'
    },
    languages: {
        de: 'German',
        en: 'English',
        pt: 'Portuguese'
    },
    language: {
        choose: {
            label: 'Choose your language:'
        }
    },
    hint: {
        instancename: 'Maximum 30 characters, only a-z, 0-9 and - allowed',
        appellation: 'Form of address',
        discountcode: 'For a later paid license',
        heardfrom: 'How have you heard from us?',
        testChurchTools:
            'Test the full functionality of ChurchTools free of charge for 30 days. The trial period ends automatically without the need to cancel.',
        testChurchToolsPlusWebsite:
            'Test the full functionality of ChurchTools and ChurchTools Website free of charge for 30 days. The trial period ends automatically without the need to cancel.',
        testWebsite: '30 days free full feature trial',
        setupServiceOptional:
            'We are happy to help you get started with ChurchTools and support you with the initial setup. For this purpose, we offer you a free 1-hour Zoom meeting, in which also other people from your congregation are welcome to participate. During the meeting, we will work together to make the first settings for your new ChurchTools installation, so that you can then continue testing optimally.',
        setupServiceMandatory:
            'We help you with the first steps with ChurchTools and support you with the initial setup. For this purpose, we will hold a free 1-hour zoom meeting with you, in which also other people from your congregation are welcome to participate. During the meeting, we will work together to make the first settings for your new ChurchTools installation, so that you can then continue testing optimally.',
        churchtoolsWebsite:
            'With <a href="https://church.tools/website" target="_blank">ChurchTools Website</a> you can easily present your church in your individual way with prefabricated layouts. You can display people, groups and dates on the website with a few clicks using the editor and update them directly from ChurchTools.',
        startTestphaseFromChurchTools:
            'In this case, the test phase for ChurchTools Website must be started directly from ChurchTools. In the Manage menu, go to "Public Relations" and then to "ChurchTools Website".',
        // next line in english
        contactSupportForCWBKircheHamburg: '',
        freeCombo:
            'With ChurchTools Website, your church congregation also gets a permanently free Combo package of <a href="https://church.tools" target="_blank">ChurchTools</a>.',
        institutionId: ''
    },
    appellation: {
        mrs: 'Ms.',
        mr: 'Mr',
        not_specified: 'not specified'
    },
    heardfrom: {
        friend: 'from a friend or a colleague',
        church: 'from another church',
        google: 'Search engine like Google or Yahoo',
        facebook: 'Facebook',
        instagram: 'Instagram',
        capterra: 'Capterra',
        magazine: 'from a magazine',
        conference: 'from a conference or an exhibition',
        other: 'other'
    },
    buttonorderforfree: 'Request for free',
    requiredfield: '* indicates a required field',
    email: {
        subject: {
            validation: '[ChurchTools] Confirm your registration',
            welcome: 'Welcome to ChurchTools',
            day25: 'ChurchTools trial period ends in 5 days',
            day30: 'Your free ChurchTools trial period ends today',
            day45: 'A bad and a good news',
            day80: 'We are sorry for this...',
            day90: 'Is this a goodbye?',
            duplicate: '[ChurchTools] Duplicate installation',
            licenseChange: 'ChurchTools license change',
            licenseOrderConfirmation: 'ChurchTools order confirmation',
            soondeleteinstance: '[ChurchTools] Your installation is inactive',
            deleteinstance: '[ChurchTools] Your installation was deleted',
            newlicensemodel: 'Important news from ChurchTools',
            siteCreated: 'ChurchTools instance created'
        },
        logo: 'https://ccp.church.tools/images/ct-logo-slogan-en.png'
    },
    header: {
        greeting: 'Hello {appellation} {name}',
        register: 'Register for a free ChurchTools installation',
        location: 'Location: {location}',
        church: 'Church: {church}'
    },
    register: {
        header: 'Get ChurchTools 30 days for free',
        headerWebsite: 'Test ChurchTools Website for free',
        headerFinder: 'Register ChurchTools for your finder profile for free',
        headerDenomination: 'Register ChurchTools for',
        headerDenominationWebsite: 'Register ChurchTools Website for',
        headerDenominationUpdateAdmin: 'Update ChurchTools admin for',
        headerinstanceavailable:
            '🎉 Congratulations, this address is still available. Get ChurchTools 30 days for free now',
        finished: {
            description:
                'To complete the installation, please confirm your email address. We have sent you a mail to {email}. Please click on the link in the email.',
            descriptionDenomination:
                'The ChurchTools installation will now be created. It will take a few minutes.</br></br>As soon as this is finished we will send an email to</br>{email} (administrator)</br>and</br>{denominationEmail} ({denominationName}).',
            duplicate:
                'Thank you for registering! Our support team will take care of the installation and send you an email to {email}',
            header: 'Your ChurchTools installation has been requested',
            resend: 'Send email again',
            editEmail: 'Correct email address',
            resendEmail: {
                success: 'The email to confirm your email address has been resent',
                error: 'The email could not be send. Please try again later.'
            },
            saveEmail: 'save',
            changeEmail: {
                success:
                    'The email adress has been sucessfully changed. An email to confirm your email adress has been resent',
                error: 'The email adress could not be changed.'
            },
            status: 'Setup status',
            again: 'Register further installations'
        }
    },
    setup: {
        status: {
            header: 'Thank you for confirming your email address!',
            headerDenomination: 'Thank you for the registration!',
            description:
                'Your ChurchTools installation will now be provided for you. It will take a few minutes. Please be patient for a moment.',
            error:
                'Unfortunately, an error has occurred during your installation. We will try to fix it as soon as possible and contact you via your email address {email}'
        },
        finished: {
            header: 'Setup is finished',
            description:
                'You can now login with your email {email} and password "admin". Go to your Instance <a href="https://{siteName}.church.tools">{siteName}.church.tools</a>.',
            descriptionWebsite:
                'You can now log in with the credentials from the welcome email and then change your password.',
            login: 'Login'
        }
    },
    validation: {
        wait: 'Validating validationToken {token}, please be patient...',
        email: 'This field needs a valid email-adress',
        empty: 'This field can not be empty.',
        exactlength: 'This field must have a length of {length}.',
        allowed: 'This field must contain one of the following values: {allowed}.',
        length: 'This field can only take between {min} and {max} characters.',
        minlength: 'This field must have at least {min} characters',
        maxlength: 'This field can only take up to {max} characters',
        sitename: {
            invalidchars: 'The field contains invalid characters, only a-z, 0-9 and - are allowed.',
            taken: 'We are sorry. The site name is already taken.',
            notYetKnown: 'This site name is not yet known.'
        },
        errorHeader: 'Error validating the email.',
        churchname: 'Please enter the full name of your church (at least 5 characters).',
        duplicateEmail: 'Only one installation per church is allowed.',
        adminAlreadyExists: 'An admin already exists in this installation. Update not possible.'
    },
    error: {
        fielderrors: 'There are validation errors.',
        noresendtoken: 'No resend-token given.',
        notoken: 'No token given.',
        novalidationtoken: 'No validation token given.',
        emailvalidated: 'The email was already validated.',
        sitenamealreadyprogress: 'A installation with the same site name is already in progress.',
        tokeninvalid: 'The given token is not valid.',
        licensekeyinvalid: 'The given license key is not valid.',
        internal:
            'Unfortunately, an error has occurred during your installation. We will try to fix it as soon as possible and contact you via your email address {email}'
    },
    countries: {
        '---': '-----',
        AF: 'Afghanistan',
        EG: 'Egypt',
        AX: 'Åland Islands',
        AL: 'Albania',
        DZ: 'Algeria',
        AS: 'American Samoa',
        VI: 'Virgin Islands, U.s.',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctica',
        AG: 'Antigua And Barbuda',
        GQ: 'Equatorial Guinea',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AC: 'Ascension Island',
        AZ: 'Azerbaijan',
        ET: 'Ethiopia',
        AU: 'Australia',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BE: 'Belgium',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolivia',
        BA: 'Bosnia And Herzegovina',
        BW: 'Botswana',
        BV: 'Bouvet Island',
        BR: 'Brazil',
        VG: 'British Virgin Islands',
        IO: 'British Indian Ocean Territory',
        BN: 'Brunei Darussalam',
        BG: 'Bulgaria',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        CL: 'Chile',
        CN: 'China',
        CK: 'Cook Islands',
        CR: 'Costa Rica',
        DK: 'Denmark',
        DE: 'Germany',
        SH: 'Saint Helena',
        DG: 'Diego Garcia',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        DJ: 'Djibouti',
        EC: 'Ecuador',
        SV: 'El Salvador',
        ER: 'Eritrea',
        EE: 'Estonia',
        EU: 'European Union',
        FK: 'Falkland Islands (malvinas)',
        FO: 'Faroe Islands',
        FJ: 'Fiji',
        FI: 'Finland',
        FR: 'France',
        GF: 'French Guiana',
        PF: 'French Polynesia',
        TF: 'French Southern Territories',
        GA: 'Gabon',
        GM: 'The Gambia',
        GE: 'Georgia',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GD: 'Grenada',
        GR: 'Greece',
        GL: 'Greenland',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GN: 'Guinea',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heard Island And Mcdonald Islands',
        HN: 'Honduras',
        HK: 'Hong Kong',
        IN: 'India',
        ID: 'Indonesia',
        IQ: 'Iraq',
        IR: 'Iran',
        IE: 'Ireland',
        IS: 'Iceland',
        IM: 'Isle Of Man',
        IL: 'Israel',
        IT: 'Italy',
        JM: 'Jamaica',
        JP: 'Japan',
        YE: 'Yemen',
        JE: 'Jersey',
        JO: 'Jordan',
        KY: 'Cayman Islands',
        KH: 'Cambodia',
        CM: 'Cameroon',
        CA: 'Canada',
        IC: 'Canary Islands',
        CV: 'Cape Verde',
        KZ: 'Kazakhstan',
        QA: 'Qatar',
        KE: 'Kenya',
        KG: 'Kyrgyzstan',
        KI: 'Kiribati',
        CC: 'Cocos (keeling) Islands',
        CO: 'Colombia',
        KM: 'Comoros',
        CD: 'Congo, The Democratic Republic Of The',
        HR: 'Croatia',
        CU: 'Cuba',
        KW: 'Kuwait',
        LA: "Lao People's Democratic Republic",
        LS: 'Lesotho',
        LV: 'Latvia',
        LB: 'Lebanon',
        LR: 'Liberia',
        LY: 'Libya',
        LI: 'Liechtenstein',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        MO: 'Macao',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Maldives',
        ML: 'Mali',
        MT: 'Malta',
        MA: 'Morocco',
        MH: 'Marshall Islands',
        MQ: 'Martinique',
        MR: 'Mauritania',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MK: 'Republic of Macedonia',
        MX: 'Mexico',
        FM: 'Micronesia, Federated States Of',
        MD: 'Moldova',
        MC: 'Monaco',
        MN: 'Mongolia',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MZ: 'Mozambique',
        MM: 'Burma',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NC: 'New Caledonia',
        NZ: 'New Zealand',
        NT: 'Saudi–Iraqi neutral zone',
        NI: 'Nicaragua',
        NL: 'Netherlands',
        AN: 'Netherlands Antilles',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        KP: 'North Korea',
        MP: 'Northern Mariana Islands',
        NF: 'Norfolk Island',
        NO: 'Norway',
        OM: 'Oman',
        AT: 'Austria',
        TL: 'East Timor',
        PK: 'Pakistan',
        PS: 'Palestinian Territory, Occupied',
        PW: 'Palau',
        PA: 'Panama',
        PG: 'Papua New Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PH: 'Philippines',
        PN: 'Pitcairn',
        PL: 'Poland',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        CI: "CÔte D'ivoire",
        CG: 'Congo',
        RE: 'RÉunion',
        RW: 'Rwanda',
        RO: 'Romania',
        RU: 'Russian Federation',
        SB: 'Solomon Islands',
        ZM: 'Zambia',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'Sao Tome And Principe',
        SA: 'Saudi Arabia',
        SE: 'Sweden',
        CH: 'Switzerland',
        SN: 'Senegal',
        RS: 'Serbia',
        CS: 'Serbia and Montenegro',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        ZW: 'Zimbabwe',
        SG: 'Singapore',
        SK: 'Slovakia',
        SI: 'Slovenia',
        SO: 'Somalia',
        SU: 'Soviet Union',
        ES: 'Spain',
        LK: 'Sri Lanka',
        KN: 'Saint Kitts And Nevis',
        LC: 'Saint Lucia',
        PM: 'Saint Pierre And Miquelon',
        VC: 'Saint Vincent and the Grenadines',
        ZA: 'South Africa',
        SD: 'Sudan',
        GS: 'South Georgia And The South Sandwich Islands',
        KR: 'South Korea',
        SR: 'Suriname',
        SJ: 'Svalbard And Jan Mayen',
        SZ: 'Swaziland',
        SY: 'Syrian Arab Republic',
        TJ: 'Tajikistan',
        TW: 'Taiwan',
        TZ: 'Tanzania, United Republic Of',
        TH: 'Thailand',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad And Tobago',
        TA: 'Tristan da Cunha',
        TD: 'Chad',
        CZ: 'Czech Republic',
        TN: 'Tunisia',
        TR: 'Turkey',
        TM: 'Turkmenistan',
        TC: 'Turks And Caicos Islands',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraine',
        HU: 'Hungary',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VU: 'Vanuatu',
        VA: 'Vatican City',
        VE: 'Venezuela',
        AE: 'United Arab Emirates',
        US: 'United States of America',
        GB: 'United Kingdom',
        VN: 'Viet Nam',
        WF: 'Wallis And Futuna',
        CX: 'Christmas Island',
        BY: 'Belarus',
        EH: 'Western Sahara',
        CF: 'Central African Republic',
        CY: 'Cyprus',
        BQ: 'Bonaire',
        BL: 'Saint-Barthélemy',
        MF: 'Saint Martin',
        KO: 'Kosovo',
        SS: 'South Sudan',
        CW: 'Curacao',
        SX: 'Sint Maarten',
        UM: 'United States Minor Outlying Islands'
    },
    support: {
        dashboard: {
            tabs: {
                errors: 'Errors',
                pendings: 'Pending',
                duplicates: 'Duplicates',
                inprogress: 'in Progress',
                finished: 'Done',
                usage: 'Usage'
            },
            searchButton: 'search',
            instancename: 'Instance name'
        },
        table: {
            updated: 'Updated',
            product: 'Product',
            sitename: 'Sitename',
            churchname: 'Church name',
            username: 'Person name',
            email: 'E-Mail',
            baselanguage: 'Base language',
            cta: 'Call to Action',
            status: 'Status'
        },
        registrationDetails: {
            header: 'Registration Information',
            contactData: 'Contact',
            churchData: 'Church',
            isDuplicate: 'Is Duplicate',
            sendNotice: 'Send notice',
            noDuplicate: 'No Duplicate',
            name: 'Name:',
            email: 'Email:',
            phone: 'Phone:',
            registerLanguage: 'Registration language:',
            churchName: 'Churchname:',
            city: 'City:',
            country: 'Country:',
            baseLanguage: 'Language:',
            instanceName: 'Instance Name:',
            website: 'Website:',
            furtherInformation: 'Further Informations',
            heardFrom: 'Heard from:',
            discount: 'Discount:',
            license: 'License:',
            created: 'created:',
            userAgent: 'Browser:',
            logs: 'Logs',
            comment: 'comment',
            cta: 'Call to action:',
            linkfreescout: 'Find in FreeScout',
            addcomment: 'Add comment',
            proceedinstallation: 'Proceed installation',
            lastupdate: 'Updated:',
            markdone: 'Mark as done',
            infomails: 'Infomails:',
            newsletter: 'Newsletter:'
        },
        usageDetails: {
            header: 'Usage details',
            usageLicenseData: 'license-relevant usage data',
            persons: 'Persons',
            services: 'Services',
            resources: 'Resources',
            calendars: 'Calendars',
            stations: 'Campuses',
            usageDataLast30Days: 'New entries within the last 30 days',
            persons30: 'Persons',
            personsActive30Days: 'Persons logged in',
            groups30: 'Groups',
            csEntries30: 'Service assignments',
            crEntries30: 'Resource bookings',
            calEntries30: 'Calendar entries',
            licenseOverUnder: 'Over-/Under-licensing',
            overLicensed: 'over-licensed',
            underLicensed: 'under-licensed'
        },
        setupState: {
            duplicate: 'Duplicate',
            possibleduplicate: 'possible Duplicate',
            error: 'Error',
            pending: 'Waiting for email validation',
            done: 'Done',
            inprogress: 'In Progress',
            manuelDone: 'marked as done'
        },
        registrationOverview: {
            noDataFound: 'No entries available'
        },
        duplicates: {
            header: 'Possible Duplicate',
            intern: 'INTERN',
            ccp: 'CCP',
            tableColumn: {
                type: 'TYPE',
                churchName: 'Churchname',
                email: 'E-Mail',
                phone: 'Phone',
                city: 'City',
                country: 'Country',
                website: 'Website',
                setupState: 'Setup State'
            }
        },
        login: {
            error: 'Username or Password is wrong.'
        }
    },
    license: {
        tax: {
            nStb: 'Amount not taxable.',
            nStbUstID: 'The VAT for this taxable service or work is owed by the recipient. Your VAT-ID is: {ustid}',
            MwSt: '19% tax.'
        },
        discount: {
            discountAmountOnSum: '{amount} from the sum{comment}',
            discountAmountOnPart: '{amount} from {part}{comment}',
            discountPercentOnSum: '{percent}% from the sum{comment}',
            discountPercentOnPart: '{percent}% from {part}{comment}',
            fixPriceForSum: 'Fix total price{comment}',
            fixPriceForPart: 'Fix total price for {part}{comment}',
            minPriceForSum: 'Add-up to negotiated minimum total price of {price}{comment}',
            minPriceForPart: 'Add-up to negotiated minimum price of {price} for {part}{comment}'
        },
        yes: 'yes',
        no: 'no',
        dateformat: 'DD/MM/YY',
        unlimited: 'unlimited',
        financeClients: 'Clients',
        syncConnections: 'Sync Connections'
    },
    demo: {
        header: 'ChurchTools Demo',
        information: {
            header: 'Information about the demo',
            text:
                'The ChurchTools Demo installation is filled with sample data to explore ChurchTools. This installation is free and will be automatically deleted after 3 days.'
        },
        support: {
            text: 'If you have any questions, our support team will be happy to help you.',
            contact: 'Contact Support'
        },
        create: {
            button: 'Create demo',
            spinner: 'We will create a new demo for you. This can take up to one minute.'
        },
        churchtools: {
            button: 'Access ChurchTools',
            text: 'Your demo has been created'
        },
        error: {
            header: 'Something went wrong',
            text:
                'It seems that there was a mistake. Unfortunately, no ChurchTools demo could be created. Please reload the page and try again. If the problem remains, our support team will be happy to help you.',
            reload: 'Reload'
        },
        template: {
            label: 'Choose a Demo:',
            freikirche: 'Free-Church',
            evangelisch: 'Protestant',
            katholisch: 'Catholic',
            cvjm: 'CVJM'
        }
    }
};
